<template>
  <el-dialog title="选择添加方式"
             :visible.sync="dialogVisible"
             width="559px">
    <div class="dialog">
      <div class="box"
           v-for="(item, index) in tabList"
           :key="index"
           @click="select(index)">
        <div class="title">
          <img :src="item.icon"
               alt="" />
          <span>{{ item.title }}</span>
        </div>
        <div class="describe">
          {{ item.describe }}
        </div>
        <img v-if="current == index"
             class="choose"
             :src="require('/src/assets/img/optFor.png')"
             alt="" />
      </div>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </span>

    <ChildLevelRelevancy @submit="$emit('submit')"
                         ref="childLevelRelevancy"></ChildLevelRelevancy>
  </el-dialog>
</template>

<script>
import ChildLevelRelevancy from '@/components/read/ChildLevelRelevancy.vue'
export default {
  components: {
    ChildLevelRelevancy,
  },
  data() {
    return {
      id: '',
      dialogVisible: false,
      current: 0,
      tabList: [
        {
          title: '新建',
          icon: require('/src/assets/img/add.png'),
          describe: '',
        },
        // {
        //   title: "关联",
        //   icon: require("/src/assets/img/relevancy.png"),
        //   describe: "如选择关联，修改时将同步修改此子级",
        // },
        {
          title: '复制',
          icon: require('/src/assets/img/copy.png'),
          describe: '如选择复制，修改时仅单独修改此子级',
        },
      ],
    }
  },

  methods: {
    open(id) {
      this.id = id
      this.dialogVisible = true
    },
    select(index) {
      this.current = index
    },
    submit() {
      switch (this.current) {
        case 0:
          this.dialogVisible = false
          this.$emit('addNewChild')
          break
        // case 1:
        //   this.dialogVisible = false
        //   this.$refs.childLevelRelevancy.open(this.id, 2)
        //   break
        case 1:
          this.dialogVisible = false
          this.$refs.childLevelRelevancy.open(this.id, 3)
          break
      }
    },
  },
}
</script>


<style lang="less" scoped>
.dialog {
  display: flex;
  justify-content: space-around;
  font-family: PingFang SC, PingFang SC;
  .box {
    width: 160px;
    height: 125px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #e4e6eb;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    cursor: pointer;
    .choose {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
    }
    .describe {
      margin-top: 11px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: center;
    }
  }
}
</style>
